/*
 * @Author: shiguang
 * @Date: 2023-04-27 14:06:40
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-06-25 11:44:26
 * @Description: 配置 axios 相关信息
 */

const getRquestBaseUrlByEnv = (env: string) => {
	const prod2 = 'https://prod-gateway.theckb.com';
	const prodUrl = 'https://gateway-prod.theckb.com';
	const preUrl = 'https://pre-gateway.theckb.com';
	// return preUrl;
	if (env === 'prod') {
		return prodUrl;
	}
	if (env === 'prod2') {
		return prod2;
	}
	if (env === 'pre') {
		return preUrl;
	}
	return `https://master-gateway.theckb.com`;
};

// 1. 可以在 url 上配置
// 2. 可以在 代码中 动态改动
// 3. 根据域名处理
export const serviceConfig = (() => {
	return {
		baseURL: (() => {
			const devUrl = 'https://master-gateway.theckb.com';
			const preUrl = 'https://pre-gateway.theckb.com';
			if (window.location.port) return preUrl;
			const arr = window.location.host.split('-');

			let [env] = arr;
			if (arr.length < 2) env = 'prod';
			return getRquestBaseUrlByEnv(env);
		})(),
		getEnv: function (): 'prod' | 'pre' | 'dev' {
			if (this.baseURL === 'https://gateway-prod.theckb.com') {
				return 'prod';
			}
			if (this.baseURL === 'https://pre-gateway.theckb.com') {
				return 'pre';
			}
			return 'dev';
		}
	};
})();
